import { render, staticRenderFns } from "./comp_WireTransferCardContent.vue?vue&type=template&id=8577bcba&"
import script from "./comp_WireTransferCardContent.vue?vue&type=script&lang=js&"
export * from "./comp_WireTransferCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports